export default "__VITE_ASSET__BJejCQEQ__"